import { render, staticRenderFns } from "./PDCA.vue?vue&type=template&id=310e3f6a&scoped=true"
import script from "./PDCA.vue?vue&type=script&lang=js"
export * from "./PDCA.vue?vue&type=script&lang=js"
import style0 from "./PDCA.vue?vue&type=style&index=0&id=310e3f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e3f6a",
  null
  
)

export default component.exports